<template lang="pug">
  .v-input-password(:class="classes")
    .v-input-password__wrapper
      input.v-input-password__field(
        required
        :type="passwordFieldType"
        :value="value"
        :autocomplete="autocomplete"
        @input="onChange")
      label.v-input-password__label {{ label }}
      .v-input-password__bar
      .v-input-password__hint(v-if="hint") {{ hint }}
      button.v-input-password__btn(
        @click="switchVisibility")
        span.v-input-password__icon
          font-awesome-icon(
            size="sm"
            :icon="activeField ? 'eye' : 'eye-slash'")
</template>

<script>

export default {
  name: 'VPasswordField',

  props: {
    value: {
      type: String,
      default: null
    },
    label: {
      type: String,
      default: null
    },
    autocomplete: {
      type: String,
      default: 'off'
    },
    invalid: {
      type: Boolean,
      default: true
    },
    hint: {
      type: String,
      default: null
    }
  },

  data: () => ({
    activeField: false,
    passwordFieldType: 'password'
  }),

  computed: {
    classes () {
      return {
        'v-input-password--invalid': this.invalid
      }
    }
  },

  methods: {
    onChange (event) {
      this.$emit('input', event.target.value)
    },

    switchVisibility () {
      this.passwordFieldType = this.passwordFieldType === 'password'
        ? 'text'
        : 'password'
      this.activeField = !this.activeField
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/sass/abstracts/_variables.scss';

.v-input-password {
  position: relative;

  &__wrapper {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  &__label {
    position: absolute;
    pointer-events: none;
    font-size: 1.5rem;
    color: $color-gray;
    top: 1rem;
    transition: .3s ease all;
  }

  &__field {
    position: relative;
    display: block;
    padding: 1rem 2.6rem .8rem 0;
    width: 100%;
    border-bottom: .1rem solid $color-gray-light-2;
    font-size: 1.5rem;
    color: $color-black;
    outline: none;
    z-index: 1;
    background: transparent;

    &::placeholder {
      color: inherit;
    }

    &:focus {
      outline: none;
    }

    &:focus ~ label,
    &:valid ~ label {
      top: -.8rem;
      font-size: 1.3rem;
      color: $color-gray;
    }

    &:focus ~ .v-input-password__bar:before,
    &:focus ~ .v-input-password__bar:after {
      width: 50%;
    }
  }

  &__bar {
    position: relative;

    &:before,
    &:after {
      content: "";
      height: .2rem;
      width: 0;
      bottom: .1rem;
      position: absolute;
      background: $color-primary;
      transition: 0.2s ease all;
    }

    &:before {
      left: 50%;
    }

    &:after {
      right: 50%;
    }
  }

  &__hint {
    color: $color-red;
    font-size: 1.2rem;
    font-weight: 300;
    padding-top: .3rem;
  }

  &__btn {
    cursor: pointer;
    position: absolute;
    outline: none;
    right: 0;
    top: 0;
    height: 4rem;
    width: 1.8rem;
    z-index: 1;
  }

  &--invalid {
    label {
      color: $color-red !important;
    }
  }
  
  &--invalid &__icon {
    color: $color-red !important;
  }

  &--invalid &__field {
    color: $color-red !important;
    border-bottom: .2rem solid $color-red !important;
  }

  &--invalid &__bar {
    &:before,
    &:after {
      background-color: transparent !important;
    }
  }
}
</style>
